import { Component, OnInit } from '@angular/core';

@Component({
  selector:    'app-test',
  templateUrl: 'test.component.html',
  styleUrls:   ['test.component.less']
})
export class TestComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/test/test.component.ts